import React, { useContext } from "react"
import liff from '@line/liff';
import * as api from '../api/Profile'
import { Container, Box, Typography, Button, Stack } from "@mui/material"
import * as dictRegister from "../dictionary/Register";
import * as dictProfile from "../dictionary/Profile";
import { ProfileContext } from "../contexts/ProfileContext";

export const RestoreLogin = () => {
  let profile_lineOA = JSON.parse(localStorage.getItem("profile_lineOA"))
  const context = useContext(ProfileContext);
  const { profile } = context.state;

  const userLanguage = profile?.customer?.[0]?.language || "th"

  const logoutService = async () => {
    let res = await api.logout({
      "line_id": profile_lineOA?.profile.userId
    })

    if (res.data?.status !== 200) {
      return
    }

    // liff.logout()
    localStorage.clear()
    liff.closeWindow()
    return
  }

  const restoreUserLoginService = async () => {
    try{
      let res = await api.restoreUserLogin({
        "line_id": profile_lineOA?.profile.userId,
        "company_id": profile_lineOA?.cid || profile_lineOA?.cid_pm || profile_lineOA?.cid_rental
      })
      if (res?.status === 200) {
        const my_home_url = res.data?.line_my_home_url
        window.location.href = my_home_url
      }
    }
    catch (error) {
      console.log(error)
    }
  }
  return (
      <>
          <Container>
              <Box sx={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  /* bring your own prefixes */
                  transform: "translate(-50%, -50%)",
                  textAlign: "center"
              }}>

                  <Typography>
                      { dictRegister.Is_User_Login_TXT[userLanguage]}
                  </Typography>
                  <Stack direction={"row"} spacing={3} mt={2} justifyContent={"center"}>
                      <Button variant="contained" color={"info"} sx={{ minWidth: "120px"}}><Typography variant='body2' onClick={restoreUserLoginService}>{dictRegister.Restore_Login_TXT[userLanguage]}</Typography></Button>
                      <Button variant="contained" color={"error"} sx={{ minWidth: "120px"}}><Typography variant='body2' onClick={logoutService}>{dictProfile.Logout_TXT[userLanguage]}</Typography></Button>
                  </Stack>
              </Box>
          </Container>
      </>
  )
}